import React, {useMemo, useRef} from "react";
import {Pie} from "react-chartjs-2";

const MetricGraphicComponent = ({metrics, onClick}) => {
    const chartRef = useRef(null);

    const chartData = useMemo(() => ({
        labels: ['Traducido', 'Traducción Parcial' ,'Sin Traducir'],
        datasets: [{
            data: [metrics?.percentageTranslatedRegisters || 0.0 ,  metrics?.percentagePartiallyTranslatedRegisters || 0.0, !metrics ? 100.0 :(metrics?.percentageUntranslatedRegisters || 0.0)],
            borderColor: ['rgb(96,140,48)', 'rgb(239, 152, 67)', 'rgb(234, 97, 53)'],
            backgroundColor: ['rgba(96,140,48, .60)', 'rgba(239, 152, 67, .60)', 'rgba(234, 97, 53, .60)'],
            borderWidth: 1,
        }]
    }), [metrics])


    const chartOptions = useMemo(() => ({
        responsive : true,
        plugins: {
            legend: {
                position: 'top',
                align: 'start',
            },
            title: {
                display: false,
                text: ""
            },
            datalabels: {
                display: true,
                color: 'black',
                font: { weight: 'bold' },
                formatter: value => (value === 0) ? '' : `${value}%`
            },
            tooltip: {
                callbacks: {
                    label: context => {
                        let label = context.label || '';
                        if (label)
                            label += ': ';

                        if (context.raw !== null)
                            label += context.raw + '%';

                        return label;
                    }
                }
            }
        },
    }), [])

    const handleClick = (event) => {
        const chart = chartRef.current;
        if(!chart)
            return

        const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
        if (elements.length)
            onClick(event);
    };

    return <>
        <div className={'section-graphics graphic-clickable'}>
            <Pie
                ref={chartRef}
                data={chartData}
                options={chartOptions}
                onClick={handleClick}
            />
        </div>
        {
            metrics && <div className={'section-see-more'}>
                <div className="float-right">
                    <span onClick={onClick}>Ver mas...</span>
                </div>
            </div>
        }
    </>
}

export default React.memo(MetricGraphicComponent)